/**
 * 비차단 경고 카드 (W1 · DESIGN §4).
 *
 * 저작이 남긴 경고는 **진행을 막지 않는다**(BR-501/502 · 절대규칙 5: 막는 유일한 조건은
 * 비가역성이다). 그래서 황색 카드이고, 기본 접힘이며, 다운로드 버튼과 나란히 산다.
 * 빨강(danger)을 쓰지 않는 이유가 여기 있다 — 빨강은 이 화면에서 "되돌릴 수 없음"과
 * "실패했음" 두 맥락 전용이다(P3′).
 *
 * 서버는 이 배열을 늘 주는데 화면이 여태 버리고 있었다 — 사람이 봐야 하는 것을 계산만 하고
 * 안 보여주면 없는 것과 같다.
 */
import { useTranslation } from 'react-i18next'

import { TriangleAlert } from '@/ui/icons'

export function WarningsCard({ warnings }: { warnings: string[] }) {
  const { t } = useTranslation()
  if (warnings.length === 0) return null

  return (
    <details className="card warn">
      <summary>
        <TriangleAlert size={15} />
        {t('warn.title', { count: warnings.length })}
        <span className="count">{t('warn.nonblocking')}</span>
        <span className="chev" aria-hidden="true" />
      </summary>
      <div className="warn-list">
        {warnings.map((warning, index) => (
          <div className="warn-row" key={`${index}-${warning}`}>
            <span className="warn-text">{warning}</span>
          </div>
        ))}
      </div>
    </details>
  )
}
